import axios from 'axios';
import snakeobj from 'snakeobj';
import camelobj from 'camelobj';
import { get } from 'lodash';
import uuid from 'uuid/v4';
import storage from './storage';
import { getParameterByName } from './functions';
import { reportError } from './error-reporter';
import ApiError from './api-error';
import detectLanguage from './detect-language';

const env = global.pbgEnv;
const {
  REACT_APP_API_HOST,
} = env;

const consumerApi = axios.create();

consumerApi.defaults.baseURL = REACT_APP_API_HOST;
consumerApi.defaults.headers.common['Content-Type'] = 'application/json';
consumerApi.defaults.headers.common.Accept = 'application/json';
consumerApi.defaults.transformRequest = [
  ...axios.defaults.transformRequest,
  (data) => {
    if (!data) return undefined;
    if (data instanceof FormData) return data;
    return JSON.stringify(snakeobj(JSON.parse(data)));
  },
];
consumerApi.defaults.transformResponse = [
  ...axios.defaults.transformResponse,
  data => camelobj(data),
];

consumerApi.interceptors.request.use(
  (config) => {
    const newConfig = { ...config };
    const language = detectLanguage() || 'en';

    if (config.authorization && config.authorization.bearer) {
      newConfig.headers.Authorization = `Bearer ${config.authorization.bearer}`;
    }

    newConfig.headers['Access-Control-Expose-Headers'] = 'Session-Id, X-UPDATED-JWT, X-Invalid-Auth-Token';

    if (language) {
      newConfig.headers['Accept-Language'] = language;
    }

    return newConfig;
  },
  error => error,
);

consumerApi.interceptors.request.use(
  (config) => {
    const newConfig = { ...config };
    const sessionId = getParameterByName('sessionId') || storage.getItem('sessionId') || uuid();

    storage.setItem('sessionId', sessionId);
    newConfig.headers['Session-Id'] = sessionId;

    return newConfig;
  },
  error => error,
);

consumerApi.interceptors.response.use(
  res => handleResponse(res),
  err => handleApiErrors(err),
);

consumerApi.interceptors.response.use(
  res => updateJWT(res),
  err => handleSessionExipred(err),
);

const handleResponse = (response) => response;

const handleApiErrors = (error, more) => {
  const apiError = ApiError.isApiError(error) ? new ApiError(error) : null;
  if (!apiError) return Promise.reject(error);

  if (apiError.is500) {
    window.location.href = `/${error.response.status}`;
  }

  if (apiError.is401 && !apiError.fromAuthentication) {
    reportError({ error, component: 'ApiLayer', params: {} });
    // window.location.href = `/logout`;
  }

  return Promise.reject(apiError);
}

const updateJWT = (response) => {
  const headers = response.headers;

  if (headers['x-updated-jwt']) {
    const user = storage.getItem('auth');

    if (user) {
      user.accessToken = headers['x-updated-jwt'];
      storage.setItem('auth', user);
    }
  }

  return response;
}

const handleSessionExipred = (error) => {
  const headers = get(error, 'response.headers', {});

  if (headers['x-invalid-auth-token']) {
    storage.removeItem('auth');
    window.location.reload();
  }

  return Promise.reject(error);
};

export default {
  get: consumerApi.get,
  post: consumerApi.post,
  put: consumerApi.put,
  patch: consumerApi.patch,
  delete: consumerApi.delete,
};



// WEBPACK FOOTER //
// ./src/lib/api.js